import "../../helpers/handlebars-helpers.js";
import {
  Observable,
  OperatorFunction,
  combineLatestWith,
  map,
  pipe as rxjsPipe,
  tap,
} from "rxjs";
import { includes } from "lodash-es";
import { UGElement } from "src/js/models/module.js";
import { ToggleableButton } from "../button/button.js";
import { option } from "fp-ts";
import { hide } from "src/js/helpers/dom-element-helpers.js";
import { IQueryService, QueryService } from "src/js/services/query-service.js";
import { pipe } from "fp-ts/lib/function.js";

export class OtherFavoritesFilter {
  static FromButton(
    button: HTMLElement,
    FavoriteIds$: Observable<number[]>
  ): OperatorFunction<UGElement[], UGElement[]> {
    // Hide button "other users favorites" if "bruger" og "favoritter" is not in url
    const queryService = new QueryService();

    this.hideOtherUsersFavoritesButtonBasedOnQueryParams(queryService, button);

    let initialState = pipe(
      queryService,
      this.shouldShowOtherUsersFavoritesButton,
      option.of
    );

    let ButtonState$ = ToggleableButton.getState$(button, initialState);

    return rxjsPipe(
      combineLatestWith(ButtonState$, FavoriteIds$),
      map(([elements, isActive, favoriteIds]) =>
        isActive
          ? elements.filter((element) => includes(favoriteIds, element.id))
          : elements
      )
    );
  }

  private static hideOtherUsersFavoritesButtonBasedOnQueryParams(
    queryService: IQueryService,
    otherFavoritesButton: HTMLElement
  ) {
    if (this.shouldShowOtherUsersFavoritesButton(queryService)) {
      return;
    }
    hide(otherFavoritesButton);
  }

  private static shouldShowOtherUsersFavoritesButton(
    queryService: IQueryService
  ) {
    const doesOtherUserExist = option.isSome(queryService.get("bruger"));
    const doesOtherAnonymusExist = option.isSome(
      queryService.get("favoritter")
    );

    return doesOtherUserExist || doesOtherAnonymusExist;
  }
}
